module.exports = __webpack_public_path__ + "assets/54dbf67ac7e324ab2b13052194716209.png";